'use strict';

import { app } from '../../../../../bootstrap/core';

import { statusVerifyModalComponent } from './statusVerifyModal.component';

app.component('statusVerifyModalComponent', statusVerifyModalComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/verify/components/statusVerifyModal/statusVerifyModal.js